import { createSelector } from 'reselect';

import {
  getCurrentLocationCreatedAt,
  getOBEDirectMailReactivationFreeTrialEnabled,
  getOnboardingTrialSource,
} from 'selectors/session';

import { daysDiffFromToday } from 'util/dateTime';

export const getStepData = (state, step) =>
  state.getIn(['segmentedOnboarding', step]);

export const getOnboardingTrialSourceIsDirectMail = createSelector(
  getOnboardingTrialSource,
  onboardingTrialSource => onboardingTrialSource === 'direct_mail_free_trial'
);

export const getOnboardingTrialSourceIsReactivationFreeTrial = createSelector(
  getOnboardingTrialSource,
  onboardingTrialSource => onboardingTrialSource === 'reactivation_free_trial'
);

export const isEnrolledInReactivationFreeTrial = createSelector(
  getOBEDirectMailReactivationFreeTrialEnabled,
  getOnboardingTrialSourceIsReactivationFreeTrial,
  (
    rolloutOBEDirectMailReactivationFreeTrialEnabled,
    isOnboardingTrialSourceIsReactivationFreeTrial
  ) =>
    rolloutOBEDirectMailReactivationFreeTrialEnabled &&
    isOnboardingTrialSourceIsReactivationFreeTrial
);

export const getIsDirectMailReturningUser = createSelector(
  getCurrentLocationCreatedAt,
  isEnrolledInReactivationFreeTrial,
  (locationCreatedDate, isReturningUser) =>
    isReturningUser && daysDiffFromToday(locationCreatedDate) > 30
);
